import styled from 'styled-components';
import tw from 'twin.macro';

export const FieldContainer = styled.div`
  ${tw`w-full`}
  display: ${(props) => (props.isHidden ? 'none' : 'block')};
  ${(props) => (props.isMarginBottomZero ? tw`mb-0` : tw`mb-4`)};
  ${(props) => props.css};
  -webkit-tap-highlight-color: transparent;

  .customPickerHintClassName {
    height: 0px;
  }
`;
